// extracted by mini-css-extract-plugin
export default {"main":"yca-z"};